
<app-icon 
	class="icon icon-option" 
	name="{{ icon }}"
	[class.hidden]="(buttonActive$ | push) || buttonActive"
></app-icon>
<app-icon 
	class="close icon-option" 
	name="close"
	[class.hidden]="!(buttonActive$ | push) && !buttonActive"
></app-icon>